import { Navigate, useParams } from 'react-router-dom';
import {
  getStoredInviteToken,
  normalizeInviteToken,
  setStoredInviteToken,
} from '@/helpers/inviteToken';
import { clearOnboardingGuest } from '@/helpers/onboardingGuest';
import { clearOnboardingSessionId } from '@/helpers/onboardingSession';

/**
 * Rota de entrada do link único de convite:
 * https://foto.identila.com.br/<event-slug>/link/<token>. Persiste o token e
 * manda para o início do funil (o /identify redireciona para /invite quando há
 * token guardado). Token malformado → funil normal (cai no 404 do /invite).
 *
 * Link de OUTRA pessoa na mesma aba (computador compartilhado: o titular
 * conclui e cola ali o link do acompanhante) começa uma visita nova. Sem isso
 * o convidado anterior, já com biometria, seguia no storage: o /invite abria o
 * grupo dele ("biometria pronta") e o dono do link nunca era amarrado.
 */
export function LinkTokenRoute(): JSX.Element {
  const { token } = useParams<{ token: string }>();
  const normalized = normalizeInviteToken(token ?? null);
  if (normalized !== null) {
    if (normalized !== getStoredInviteToken()) {
      clearOnboardingGuest();
      clearOnboardingSessionId();
    }
    setStoredInviteToken(normalized);
  }
  return <Navigate to="/welcome" replace />;
}
